import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
    button: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
    },
}));

export const useMenuItemStyles = makeStyles()(() => ({
    root: {
        padding: '16px 32px',
    },
}));
